import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const longDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

const CopyFromPreviousDialog = ({
  open, onOpenChange,
  sourceName,
  options,
  value, onValueChange,
  countRowsFn,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="copy-from-previous-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading tracking-tight">Copy from a previous reporting date</DialogTitle>
        <DialogDescription>
          Pick any earlier reporting date. Its rows for <span className="font-semibold">{sourceName}</span> will be loaded into the grid so you can edit before saving.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 py-2">
        <Label className="overline">Source reporting date</Label>
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger data-testid="copy-from-select"><SelectValue placeholder="Select a reporting date…" /></SelectTrigger>
          <SelectContent>
            {options.length === 0 && <div className="px-3 py-2 text-xs text-[#AAA]">No other reporting dates yet.</div>}
            {options.map((s) => {
              const rCount = countRowsFn(s.id);
              return (
                <SelectItem key={s.id} value={s.id} disabled={rCount === 0}>
                  {longDate(s.date)}
                  <span className="text-[11px] text-[#787872] font-mono ml-2">
                    · {rCount} row{rCount === 1 ? '' : 's'}
                  </span>
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <button className="btn-secondary" onClick={() => onOpenChange(false)}>Cancel</button>
        <button className="btn-primary" onClick={onConfirm} data-testid="confirm-copy-from">Copy rows</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CopyFromPreviousDialog;
